
const imgGallery = () => {
    return (
    <a className="project-link" href="https://imgalleri.onrender.com/" target="_blank" rel="noopener noreferrer">
        <div className="imgalleri">
            <div className="project-header">
                <img src="./images/imgalleri.png" alt="ImgGallery" className="project-image" />
                <h2>ImGalleri</h2>
            </div>
        </div>
    </a>
    );
};

export default imgGallery;
